export default __webpack_public_path__ + "assets/thunderstorms-night.8bb7d6ca.svg";